import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { DeleteLoad, LogisticsActionKeys } from '..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

function* deleteLoadSaga(action: DeleteLoad) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(execute, action.payload.loadNumber);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(logisticsActionCreators.removeLoad(response.value.value));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteLoad() {
  yield takeEvery(LogisticsActionKeys.DELETE_LOAD, deleteLoadSaga);
}

export async function execute(loadNumber: string): Promise<IApiExecuteRespone<IEntityWithMessages<string>>> {
  return executeApiRequest(() => httpService.delete(ApiUrls.loads({ loadNumber })));
}
